<label>
  <input
    #checkbox
    [attr.aria-label]="label"
    type="checkbox"
    [checked]="checked"
    [value]="checkboxValue"
    (click)="handleCheckboxClick(checkboxValue)"
    [disabled]="isForDisplay"
    >
    <span class="ml-1 font-normal text-[16px] shrink-0">
      {{ label }}
    </span>
    @if (hasCheckboxOtherOption) {
      <input
        type="text"
        class="border-b ml-2 w-44 md:w-full"
        [formControl]="addControl"
        [attr.aria-label]="label + 'Other'"
        [readonly]="isForDisplay"
        >
    }
  </label>
